import Cookies from 'js-cookie';
import { AUTH_COOKIES, COOKIES, OG_COOKIE } from '../constants/cookies';

export function setLastActiveCookie() {
    Cookies.set(AUTH_COOKIES.LAST_ACTIVE, Date.now().toString(), {
        sameSite: 'Lax',
        secure: true,
        path: '/',
    });
}

export async function getAccessToken() {
    return Cookies.get(AUTH_COOKIES.ACCESS_TOKEN) ?? '';
}

export function getRefreshToken() {
    Cookies.get(AUTH_COOKIES.REFRESH_TOKEN);
}

export function removeAuthTokens() {
    Cookies.remove(AUTH_COOKIES.DWSID_TOKEN);
    Cookies.remove(AUTH_COOKIES.ACCESS_TOKEN);
    Cookies.remove(AUTH_COOKIES.REFRESH_TOKEN);
    Cookies.remove(AUTH_COOKIES.ACCESS_TOKEN_SOFT);
    Cookies.remove(AUTH_COOKIES.REFRESH_TOKEN_SOFT);
    Cookies.remove(AUTH_COOKIES.LAST_ACTIVE);
    Cookies.remove(AUTH_COOKIES.TOKEN_EXPIRY);
}

export function getAccessTokenSoft() {
    return Cookies.get(AUTH_COOKIES.ACCESS_TOKEN_SOFT) ?? '';
}

export function getAnonymousIdToken() {
    return Cookies.get(AUTH_COOKIES.PETM_ANONYMOUS_KEY) ?? '';
}

export function setAnonymousIdToken(anonId: string) {
    Cookies.set(AUTH_COOKIES.PETM_ANONYMOUS_KEY, anonId);
}

export function removeAnonymousIdToken() {
    Cookies.remove(AUTH_COOKIES.PETM_ANONYMOUS_KEY);
}

export function getCustomerKey() {
    return Cookies.get(AUTH_COOKIES.PETM_CUSTOMER_KEY) ?? '';
}

export function getCartIdToken() {
    return Cookies.get(COOKIES.CART_ID) ?? '';
}

export function setCartCookie(cartId: string) {
    Cookies.set(COOKIES.CART_ID, cartId);
}

export function removeCartCookie() {
    Cookies.remove(COOKIES.CART_ID);
}

export async function removeOrderGrooveToken() {
    Cookies.remove(OG_COOKIE);
}

export function getVisitorId() {
    return Cookies.get(COOKIES.X_PETM_VISITOR_ID) ?? '';
}
